import { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { prop, propEq, defaultTo, isNil, not, all, equals } from 'ramda'
import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import PollResults from './PollResults'
import Icon from 'components/icon/Icon'

const PollCard = ({ pollingQuestion }) => {
  const { realityCheckAnswers } = useSelector(prop('onboarding'))
  // logic to set selectedAnswerIndex if there are any previous answers:
  const matchIndex = realityCheckAnswers.findIndex(
    propEq('question', prop('id', pollingQuestion))
  )
  const [selectedAnswerIndex, setSelectedAnswerIndex] = useState(
    defaultTo(null, prop(matchIndex, realityCheckAnswers)?.score - 1)
  )

  const PollAnswerOptions = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gridGap: 16 }}>
      {pollingQuestion.answers.map(({ answer }, idx) => (
        <Button
          fullWidth
          key={answer}
          onClick={() => setSelectedAnswerIndex(idx)}
          selected={equals(selectedAnswerIndex, idx)}
          variant="poll"
        >
          {answer}
        </Button>
      ))}
    </Box>
  )

  const renderPoll = all(equals(true))([not(isNil(selectedAnswerIndex))])

  const renderContent = () => {
    if (renderPoll) {
      return (
        <PollResults
          pollingQuestion={pollingQuestion}
          selectedAnswerIndex={selectedAnswerIndex}
          setSelectedAnswerIndex={setSelectedAnswerIndex}
        />
      )
    }
    return <PollAnswerOptions />
  }

  return (
    <Card
      sx={{
        maxWidth: 343,
        width: 1
      }}
    >
      <CardContent>
        <Box sx={{ alignItems: 'flex-end', display: 'flex', gridGap: 4 }}>
          <Icon sx={{ color: 'secondary.swatch' }}>bar_chart</Icon>
          <Typography color="secondary.dark" variant="overline">
            <FormattedMessage defaultMessage="Poll" id="h1gtUi" />
          </Typography>
        </Box>
        <Typography mb="24px" textAlign="left" variant="h4">
          {pollingQuestion.question}
        </Typography>
        <Typography mb="24px" textAlign="left" variant="subtitle2">
          <FormattedMessage
            defaultMessage="Select an answer to see what others said."
            id="fkOonE"
          />
        </Typography>
        {renderContent()}
      </CardContent>
    </Card>
  )
}

PollCard.propTypes = {
  pollingQuestion: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.number,
    question: PropTypes.string,
    subdomain: PropTypes.number
  }).isRequired
}

export default PollCard
